"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var Dropdown_meta_1 = require("./Dropdown.meta");
var mobx_1 = require("mobx");
var Translate_1 = require("../../base/Translate/Translate");
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var DropdownHeader_1 = __importDefault(require("./components/DropdownHeader/DropdownHeader"));
var HeaderTitle_1 = __importDefault(require("./styledComponents/HeaderTitle"));
var HeaderIcon_1 = __importDefault(require("./styledComponents/HeaderIcon"));
var List_1 = __importDefault(require("./styledComponents/List"));
var ListItems_1 = __importDefault(require("./styledComponents/ListItems"));
var ListItem_1 = __importDefault(require("./styledComponents/ListItem"));
var DropdownListItem_1 = __importDefault(require("./components/DropdownListItem/DropdownListItem"));
var ClickLayer_1 = __importDefault(require("../ClickLayer/ClickLayer"));
var Image_1 = __importDefault(require("../Image"));
var VirtualizedList_1 = __importDefault(require("../VirtualizedList"));
var Label_1 = __importDefault(require("./styledComponents/Label"));
var SearchInput_1 = __importDefault(require("./styledComponents/SearchInput"));
var HeaderItemIcon_1 = __importDefault(require("./styledComponents/HeaderItemIcon"));
var NAVIGATION_KEYS = [
    shared_1.KEYS.ESCAPE,
    shared_1.KEYS.UP_ARROW,
    shared_1.KEYS.DOWN_ARROW,
    shared_1.KEYS.PAGE_UP,
    shared_1.KEYS.PAGE_DOWN,
    shared_1.KEYS.HOME,
    shared_1.KEYS.END,
];
var ACCEPT_KEYS = [shared_1.KEYS.ENTER, shared_1.KEYS.SPACE, shared_1.KEYS.SPACEBAR];
exports.IdPrefix = 'react_dropdown_aria_';
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = Dropdown_meta_1.DROPDOWN_CATEGORY_KEY;
        _this.componentKey = Dropdown_meta_1.DROPDOWN_COMPONENT_KEY;
        _this.labelId = "dropdown_label_" + ksys_app_template_1.utils.guid.generateGuid();
        _this.headerId = "dropdown_header_" + ksys_app_template_1.utils.guid.generateGuid();
        _this.listId = "dropdown_list_" + ksys_app_template_1.utils.guid.generateGuid();
        _this.isOpen = false;
        _this.renderReordered = false;
        _this.searchTerm = '';
        _this.searchInputFocussed = false;
        _this.pinnedSelectedItems = [];
        _this.unselectedItems = [];
        _this.focusedIndex = 0;
        _this.hasTranslationContext = false;
        _this.setSearchInputFocus = function (focussed) {
            _this.searchInputFocussed = focussed;
        };
        _this.clearSearchInput = function () {
            _this.searchTerm = '';
            _this.searchInputFocussed = false;
        };
        _this.toggleSelectedValue = function (value) {
            var values;
            if (_this.isMultiSelect) {
                values = __spreadArrays(_this.selectedItems.map(function (item) { return item.value; }));
                if (_this.isValueSelected(value)) {
                    values = values.filter(function (selectedValue) { return selectedValue !== value; });
                }
                else {
                    values.push(value);
                }
            }
            else {
                values = [value];
            }
            _this.selectedValues = values;
        };
        _this.toggleOpen = function () {
            if (!_this.singleItemDisplayOnly) {
                _this.focusedIndex = 0;
                _this.isOpen = !_this.isOpen;
                if (!_this.isOpen) {
                    _this.focusHeader = true;
                }
            }
            _this.clearSearchInput();
            _this.handlePinSelected();
        };
        _this.handlePinSelected = function () {
            if (_this.pinSelected && _this.selectedItems.length > 0 && _this.isOpen) {
                // Set state for pin to top behavior
                _this.renderReordered = true;
                _this.pinnedSelectedItems = __spreadArrays(_this.selectedItems);
                _this.unselectedItems = __spreadArrays(_this.items.filter(function (item) {
                    // This prevents a deselected item to jump to original index until dropdown is closed/reopened
                    return !_this.pinnedSelectedItems.find(function (pinnedItem) { return pinnedItem.value === item.value; }) || !_this.isItemSelected(item);
                }));
            }
            else {
                // Cleanup: Reset the state to render the initial dropdown list
                _this.renderReordered = false;
                _this.pinnedSelectedItems = [];
                _this.unselectedItems = [];
            }
        };
        _this.closeDropdown = function () {
            _this.isOpen = false;
            _this.focusHeader = true;
            _this.clearSearchInput();
            _this.handlePinSelected();
        };
        _this.openDropdown = function () {
            _this.isOpen = true;
            _this.clearSearchInput();
            _this.handlePinSelected();
        };
        _this.handleOnChange = function (e, value) {
            if (e) {
                e.preventDefault();
            }
            var onChange = _this.props.onChange;
            var items = _this.items;
            _this.toggleSelectedValue(value);
            if (!_this.isMultiSelect) {
                _this.toggleOpen();
            }
            if (!ksys_app_template_1.utils.typeChecks.isNullOrEmpty(value) && onChange) {
                var index = items.findIndex(function (item) { return item.value === value; });
                onChange(_this.isMultiSelect ? _this.selectedItems : _this.selectedItems[0], index);
            }
        };
        _this.handleDropdownSearchOnChange = function (value) {
            _this.searchTerm = value;
        };
        _this.dropdownSearchCallback = function (item) {
            var searchInput = _this.props.searchInput;
            var flags = searchInput && searchInput.caseSensitive ? 'g' : 'gi';
            var term = new RegExp("" + _this.searchTerm, flags);
            return !!item.label.match(term) || false;
        };
        _this.handleKeyDown = function (e) {
            var key = e.key;
            if (NAVIGATION_KEYS.indexOf(key) !== -1) {
                e.preventDefault();
                e.stopPropagation();
                _this.onNavigation(key);
                if (!_this.isMultiSelect) {
                    _this.toggleSelectedValue(_this.items[_this.focusedIndex].value);
                }
            }
            else if (ACCEPT_KEYS.indexOf(key) !== -1 && !_this.isOpen) {
                e.preventDefault();
                _this.openDropdown();
            }
            else if (key === shared_1.KEYS.TAB) {
                _this.closeDropdown();
            }
            else if (ACCEPT_KEYS.indexOf(key) !== -1 &&
                _this.items.length > 0 &&
                _this.focusedIndex >= 0 &&
                _this.isOpen) {
                e.stopPropagation();
                e.preventDefault();
                if (_this.isMultiSelect) {
                    _this.toggleSelectedValue(_this.items[_this.focusedIndex].value);
                }
                else {
                    _this.handleOnChange(undefined, _this.items[_this.focusedIndex].value);
                }
            }
        };
        _this.renderDropdownListItem = function (item, index) {
            var _a = _this.props, _b = _a.checkboxPosition, checkboxPosition = _b === void 0 ? 'left' : _b, iconPosition = _a.iconPosition;
            var listItemId = _this.listId + "_item_" + index;
            item.focused =
                _this.items.indexOf(item) === _this.focusedIndex &&
                    !_this.searchInputFocussed;
            return (react_1.default.createElement(DropdownListItem_1.default, { id: listItemId, item: item, key: listItemId, onChange: function (e) { return _this.handleOnChange(e, item.value); }, onKeyDown: function (e) { return _this.handleKeyDown(e); }, isMultiSelect: _this.isMultiSelect, checkboxPosition: checkboxPosition, iconPosition: iconPosition, iconProps: item.iconProps, selected: _this.isItemSelected(item), isOpen: _this.isOpen }));
        };
        _this.focusedIndex = props.items.findIndex(function (item) { return item.focused; });
        return _this;
    }
    Object.defineProperty(Dropdown.prototype, "selectedItemsFromProps", {
        get: function () {
            var selectedItem = this.props.selectedItem;
            return this.convertToArray(selectedItem);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dropdown.prototype, "selectedItems", {
        get: function () {
            var _this = this;
            var items = this.items;
            var selectedItems;
            if (items && items.length > 0) {
                if (this.selectedValues) {
                    var isValueSelected_1 = function (value) {
                        if (_this.selectedValues !== undefined) {
                            return (_this.selectedValues.find(function (selectedValue) { return selectedValue === value; }) !== undefined);
                        }
                        return false;
                    };
                    selectedItems = items.filter(function (item) {
                        return isValueSelected_1(item.value);
                    });
                }
                if (!selectedItems && this.selectedItemsFromProps.length > 0) {
                    var isItemPreSelected_1 = function (item) {
                        return (_this.selectedItemsFromProps.find(function (selectedItem) { return selectedItem.value === item.value; }) !== undefined);
                    };
                    selectedItems = items.filter(function (item) { return isItemPreSelected_1(item); });
                }
            }
            if (selectedItems && selectedItems.length > 1 && !this.isMultiSelect) {
                selectedItems = [selectedItems[0]];
            }
            return selectedItems || [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dropdown.prototype, "selectedDisplayItem", {
        get: function () {
            var _a = this.props.selectedPlaceholder, selectedPlaceholder = _a === void 0 ? '{selected} selected' : _a;
            var selectedStateItems = __spreadArrays(this.selectedItems);
            if (selectedStateItems.length === 0) {
                selectedStateItems.push(this.placeholder);
            }
            var label = '';
            var iconProps;
            var translationContext = this.hasTranslationContext && this.translationContext;
            if (selectedStateItems.length > 1) {
                var values = { selected: selectedStateItems.length };
                if (translationContext) {
                    label = translationContext.translate(selectedPlaceholder, values);
                }
                label = ksys_app_template_1.utils.replacePlaceholders({ values: values, text: label });
            }
            else {
                iconProps = selectedStateItems[0].iconProps;
                if (translationContext) {
                    label = translationContext.translate(selectedStateItems[0].label);
                }
                else {
                    label = selectedStateItems[0].label;
                }
            }
            return {
                label: label,
                iconProps: iconProps,
                value: '',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dropdown.prototype, "placeholder", {
        get: function () {
            var placeholder = this.props.placeholder;
            if (this.translationContext && placeholder) {
                placeholder = this.translationContext.translate(placeholder);
            }
            return { value: '', label: placeholder };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dropdown.prototype, "singleItemDisplayOnly", {
        get: function () {
            var _a = this.props, _b = _a.singleItemDisplayOnly, singleItemDisplayOnly = _b === void 0 ? false : _b, _c = _a.items, items = _c === void 0 ? [] : _c;
            return singleItemDisplayOnly && items.length === 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dropdown.prototype, "isMultiSelect", {
        get: function () {
            var _a = this.props.isMultiSelect, isMultiSelect = _a === void 0 ? false : _a;
            return isMultiSelect;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dropdown.prototype, "dropdownAssets", {
        get: function () {
            var caretUp = this.props && this.props.dropdownAssets && this.props.dropdownAssets.caretUp;
            var caretDown = this.props && this.props.dropdownAssets && this.props.dropdownAssets.caretDown;
            return {
                caretUp: ((caretUp !== undefined) ? caretUp : 'base.dropdown.caretUp'),
                caretDown: ((caretDown !== undefined) ? caretDown : 'base.dropdown.caretDown')
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dropdown.prototype, "items", {
        get: function () {
            var _a = this.props, _b = _a.items, propsItems = _b === void 0 ? [] : _b, placeholder = _a.placeholder, _c = _a.includePlaceholderItem, includePlaceholderItem = _c === void 0 ? false : _c;
            var items = __spreadArrays(propsItems.filter(this.dropdownSearchCallback));
            if (includePlaceholderItem &&
                !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(placeholder)) {
                items.unshift(this.placeholder);
            }
            return items;
        },
        enumerable: true,
        configurable: true
    });
    Dropdown.prototype.selectSingleItem = function () {
        var _a = this.props.items, items = _a === void 0 ? [] : _a;
        if (items.length === 1) {
            this.selectedValues = [items[0].value];
        }
    };
    Dropdown.prototype.isItemSelected = function (item) {
        return (this.selectedItems.filter(function (selectedItem) { return selectedItem.value === item.value; }).length > 0);
    };
    Dropdown.prototype.isValueSelected = function (value) {
        return (this.selectedItems.filter(function (selectedItem) { return selectedItem.value === value; }).length > 0);
    };
    Dropdown.prototype.convertToArray = function (values) {
        if (values) {
            if (!ksys_app_template_1.utils.isArrayLike.isArrayLike(values)) {
                return [values];
            }
            if (ksys_app_template_1.utils.isArrayLike.isArrayLike(values)) {
                return values;
            }
        }
        return [];
    };
    /**
     * Opposed to doing a JSON.stringify (which can cause circular reference), we compare values for change
     */
    Dropdown.prototype.hasSelectedChanged = function (currSelected, nextSelected) {
        if (currSelected.length !== nextSelected.length) {
            return true;
        }
        if (currSelected.length === nextSelected.length &&
            currSelected.length > 0) {
            var _loop_1 = function (i) {
                var currItem = currSelected[i];
                if (nextSelected.find(function (nextItem) { return nextItem.value === currItem.value; }) === undefined) {
                    return { value: true };
                }
            };
            for (var i = 0; i < currSelected.length; i++) {
                var state_1 = _loop_1(i);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
        }
        return false;
    };
    Dropdown.prototype.componentWillReceiveProps = function (props) {
        // this logic allows a parent component to manage the selected values, opposed to the default internal state management
        var nextSelected = this.convertToArray(props.selectedItem);
        var currSelected = this.convertToArray(this.props.selectedItem);
        if (this.hasSelectedChanged(currSelected, nextSelected)) {
            this.selectedValues = nextSelected.map(function (item) { return item.value; });
        }
    };
    Dropdown.prototype.onNavigation = function (key) {
        var _a = this.props.pageKeyTraverseSize, pageKeyTraverseSize = _a === void 0 ? 3 : _a;
        switch (key) {
            case shared_1.KEYS.UP_ARROW:
                if (this.isOpen) {
                    if (this.focusedIndex === 0) {
                        this.focusedIndex = this.items.length - 1;
                    }
                    else {
                        this.focusedIndex = this.focusedIndex - 1;
                    }
                }
                else {
                    this.openDropdown();
                }
                break;
            case shared_1.KEYS.DOWN_ARROW:
                if (this.isOpen) {
                    this.focusedIndex =
                        (this.focusedIndex + 1) % this.items.length;
                }
                else {
                    this.openDropdown();
                }
                break;
            case shared_1.KEYS.PAGE_UP:
                if (this.isOpen) {
                    if (this.focusedIndex - pageKeyTraverseSize < 0 &&
                        this.focusedIndex !== 0) {
                        this.focusedIndex = 0;
                    }
                    else if (this.focusedIndex - pageKeyTraverseSize < 0) {
                        this.focusedIndex = this.items.length - 1;
                    }
                    else {
                        this.focusedIndex =
                            this.focusedIndex - pageKeyTraverseSize;
                    }
                }
                break;
            case shared_1.KEYS.PAGE_DOWN:
                if (this.isOpen) {
                    if (this.focusedIndex === this.items.length - 1) {
                        this.focusedIndex = 0;
                    }
                    else if (this.focusedIndex + pageKeyTraverseSize >
                        this.items.length - 1) {
                        this.focusedIndex = this.items.length - 1;
                    }
                    else {
                        this.focusedIndex =
                            (this.focusedIndex + pageKeyTraverseSize) %
                                this.items.length;
                    }
                }
                break;
            case shared_1.KEYS.HOME:
                if (this.isOpen) {
                    this.focusedIndex = 0;
                }
                break;
            case shared_1.KEYS.END:
                if (this.isOpen) {
                    this.focusedIndex = this.items.length - 1;
                }
                break;
            case shared_1.KEYS.ESCAPE:
                this.closeDropdown();
                break;
            default:
                break;
        }
    };
    Object.defineProperty(Dropdown.prototype, "selectedItemId", {
        get: function () {
            return this.listId + "_item_" + this.focusedIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dropdown.prototype, "pinSelected", {
        get: function () {
            var _a = this.props.pinSelected, pinSelected = _a === void 0 ? false : _a;
            return pinSelected;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dropdown.prototype, "itemsReorderedBySelection", {
        get: function () {
            return __spreadArrays(this.pinnedSelectedItems, this.unselectedItems).filter(this.dropdownSearchCallback).map(this.renderDropdownListItem);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dropdown.prototype, "dropdownItems", {
        get: function () {
            return this.items.map(this.renderDropdownListItem);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dropdown.prototype, "renderSearchInput", {
        get: function () {
            var _this = this;
            var searchInput = this.props.searchInput;
            if (searchInput) {
                if (!searchInput.enable) {
                    return null;
                }
                var _a = searchInput.minItems, minItems = _a === void 0 ? 10 : _a;
                if (searchInput.enable &&
                    this.searchTerm === '' &&
                    this.items.length < minItems) {
                    return null;
                }
                return (react_1.default.createElement(ListItem_1.default, null,
                    react_1.default.createElement(SearchInput_1.default, { value: this.searchTerm, onChange: function (event) {
                            return _this.handleDropdownSearchOnChange(event.target.value);
                        }, placeholder: searchInput.placeholder || 'Filter items...', onFocus: function () { return _this.setSearchInputFocus(true); }, onBlur: function () { return _this.setSearchInputFocus(false); } })));
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Dropdown.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, iconPosition = _a.iconPosition, label = _a.label, ariaControls = _a.ariaControls, _b = _a.virtualize, virtualize = _b === void 0 ? false : _b;
        var image = this.isOpen
            ? this.dropdownAssets.caretUp
            : this.dropdownAssets.caretDown;
        if (this.singleItemDisplayOnly &&
            ksys_app_template_1.utils.typeChecks.isNullOrEmpty(this.selectedValues)) {
            this.selectSingleItem();
        }
        // Used to force a render for the focus on key input
        this.focusedIndex;
        var listAriaProps = {};
        if (ariaControls) {
            listAriaProps = {
                'aria-controls': ariaControls
            };
        }
        if (this.isOpen) {
            listAriaProps = __assign(__assign({}, listAriaProps), { 'aria-activedescendant': this.selectedItemId, 'aria-controls': this.listId });
        }
        var headerItemIcon = (react_1.default.createElement(HeaderItemIcon_1.default, __assign({}, this.selectedDisplayItem.iconProps, { "aria-hidden": 'true' })));
        return (react_1.default.createElement(Wrapper_1.default, { className: className },
            label && react_1.default.createElement(Label_1.default, { id: this.labelId, value: label }),
            react_1.default.createElement(DropdownHeader_1.default, __assign({ id: this.headerId, labelId: label && this.labelId, selectedItemId: this.selectedItemId, onClick: function () { return _this.toggleOpen(); }, onKeyDown: function (e) { return _this.handleKeyDown(e); }, isOpen: this.isOpen, focus: this.focusHeader, onBlur: function () { return (_this.focusHeader = false); }, "aria-label": this.translationContext &&
                    this.translationContext.translate(this.selectedDisplayItem.label, null) }, listAriaProps),
                react_1.default.createElement(HeaderTitle_1.default, null,
                    iconPosition === 'left' && headerItemIcon,
                    react_1.default.createElement(Translate_1.TranslationContext.Consumer, null, function (translationContext) {
                        _this.translationContext = translationContext;
                        _this.hasTranslationContext = true;
                        return translationContext.translate(_this.selectedDisplayItem.label);
                    }),
                    iconPosition === 'right' && headerItemIcon),
                !this.singleItemDisplayOnly && (react_1.default.createElement(HeaderIcon_1.default, { "aria-hidden": 'true' },
                    react_1.default.createElement(Image_1.default, { asset: image })))),
            this.isOpen && (react_1.default.createElement(react_1.Fragment, null,
                react_1.default.createElement(ClickLayer_1.default, { onClick: this.toggleOpen }),
                react_1.default.createElement(List_1.default, null,
                    react_1.default.createElement(ListItems_1.default, { id: this.listId, "aria-labelledby": label && this.labelId, role: 'listbox', tabIndex: -1 },
                        this.renderSearchInput,
                        virtualize && virtualize.enable ? (react_1.default.createElement(VirtualizedList_1.default, __assign({}, virtualize.props, { items: this.renderReordered
                                ? this.itemsReorderedBySelection
                                : this.dropdownItems }))) : this.renderReordered ? (this.itemsReorderedBySelection) : (this.dropdownItems)))))));
    };
    __decorate([
        mobx_1.observable
    ], Dropdown.prototype, "isOpen", void 0);
    __decorate([
        mobx_1.observable
    ], Dropdown.prototype, "renderReordered", void 0);
    __decorate([
        mobx_1.observable
    ], Dropdown.prototype, "searchTerm", void 0);
    __decorate([
        mobx_1.observable
    ], Dropdown.prototype, "searchInputFocussed", void 0);
    __decorate([
        mobx_1.observable.ref
    ], Dropdown.prototype, "selectedValues", void 0);
    __decorate([
        mobx_1.observable.ref
    ], Dropdown.prototype, "pinnedSelectedItems", void 0);
    __decorate([
        mobx_1.observable.ref
    ], Dropdown.prototype, "unselectedItems", void 0);
    __decorate([
        mobx_1.observable.ref
    ], Dropdown.prototype, "focusedIndex", void 0);
    __decorate([
        mobx_1.observable.ref
    ], Dropdown.prototype, "focusHeader", void 0);
    __decorate([
        mobx_1.observable
    ], Dropdown.prototype, "hasTranslationContext", void 0);
    __decorate([
        mobx_1.action
    ], Dropdown.prototype, "setSearchInputFocus", void 0);
    __decorate([
        mobx_1.action
    ], Dropdown.prototype, "clearSearchInput", void 0);
    __decorate([
        mobx_1.action
    ], Dropdown.prototype, "toggleSelectedValue", void 0);
    __decorate([
        mobx_1.action
    ], Dropdown.prototype, "toggleOpen", void 0);
    __decorate([
        mobx_1.action
    ], Dropdown.prototype, "handlePinSelected", void 0);
    __decorate([
        mobx_1.action
    ], Dropdown.prototype, "closeDropdown", void 0);
    __decorate([
        mobx_1.action
    ], Dropdown.prototype, "openDropdown", void 0);
    __decorate([
        mobx_1.action
    ], Dropdown.prototype, "handleOnChange", void 0);
    __decorate([
        mobx_1.action
    ], Dropdown.prototype, "handleDropdownSearchOnChange", void 0);
    __decorate([
        mobx_1.computed
    ], Dropdown.prototype, "selectedItemsFromProps", null);
    __decorate([
        mobx_1.computed
    ], Dropdown.prototype, "selectedItems", null);
    __decorate([
        mobx_1.computed
    ], Dropdown.prototype, "selectedDisplayItem", null);
    __decorate([
        mobx_1.computed
    ], Dropdown.prototype, "placeholder", null);
    __decorate([
        mobx_1.computed
    ], Dropdown.prototype, "singleItemDisplayOnly", null);
    __decorate([
        mobx_1.computed
    ], Dropdown.prototype, "isMultiSelect", null);
    __decorate([
        mobx_1.computed
    ], Dropdown.prototype, "dropdownAssets", null);
    __decorate([
        mobx_1.computed
    ], Dropdown.prototype, "items", null);
    __decorate([
        mobx_1.action
    ], Dropdown.prototype, "isItemSelected", null);
    __decorate([
        mobx_1.computed
    ], Dropdown.prototype, "selectedItemId", null);
    __decorate([
        mobx_1.computed
    ], Dropdown.prototype, "pinSelected", null);
    __decorate([
        mobx_1.computed
    ], Dropdown.prototype, "itemsReorderedBySelection", null);
    __decorate([
        mobx_1.computed
    ], Dropdown.prototype, "dropdownItems", null);
    __decorate([
        mobx_1.computed
    ], Dropdown.prototype, "renderSearchInput", null);
    Dropdown = __decorate([
        mobx_react_1.observer
    ], Dropdown);
    return Dropdown;
}(shared_1.ComponentBase));
exports.Dropdown = Dropdown;
exports.default = shared_1.InjectedStyledComponent(Dropdown, Dropdown_meta_1.DROPDOWN_CATEGORY_KEY, Dropdown_meta_1.DROPDOWN_COMPONENT_KEY);
